import React, { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './OrganizationManagementView.css';

import { apiUrl } from '../../../utility/Connections';

import { Layout, Divider } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import TableManagementAreas from '../../../components/tableManagementAreas/tableManagementAreas';
import FormManagementAreas from '../../../components/formManagementAreas/formManagementAreas';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import Search from '../../../components/search/search';
const { Content } = Layout;

const OrganizationManagementView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [filteredDataManagementAreas, setFilteredDataManagementAreas] = useState([]);
    const [dataManagementAreas, setDataManagementAreas] = useState([]);
    const [orgId, setOrgId] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            getManagementAreas(current_org.org_id);
        }
    }, []);

    const getManagementAreas = (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando gerencias de la organización...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/management-areas/get-management-areas/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataManagementAreas(data);
                setShowLoading(false);
                if (searchText) {
                    filterData(searchText, data)
                } else {
                    setFilteredDataManagementAreas(data);
                }
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para agregar un nuevo registro de gerencia
    const addManagementArea = (newManagementArea) => {
        setShowLoading(true);
        setLoadingText("Agregando gerencia...")

        const formData = new FormData();
        formData.append("mna_org_id", orgId);
        formData.append("mna_management_area", newManagementArea);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.post(`${apiUrl}/management-areas/create-management-area/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getManagementAreas(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para editar el nombre de una gerencia
    const handleInputChangeTable = (mna_id, managementArea) => {
        setShowLoading(true);
        setLoadingText("Guardando gerencia...")

        const formData = new FormData();
        formData.append("mna_id", mna_id);
        formData.append("mna_management_area", managementArea);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.put(`${apiUrl}/management-areas/update-management-area/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getManagementAreas(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    // Función para eliminar un registro de gerencia
    const handleDeleteTable = (mna_id) => {
        setShowLoading(true);
        setLoadingText("Eliminando gerencia...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.delete(`${apiUrl}/management-areas/delete-management-area/${mna_id}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getManagementAreas(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const onSearch = (value) => {
        setSearchText(value)
        filterData(value, dataManagementAreas)
    }

    const filterData = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataManagementAreas(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.mna_management_area.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataManagementAreas(filtered);
        }
    }

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            <div className='layout-content'>
                <FormManagementAreas addManagementArea={addManagementArea} />
            </div>
            <Divider />
            <div className='layout-content'>
                <Search onSearch={onSearch} />
                <br></br>
                <TableManagementAreas data={filteredDataManagementAreas} handleInputChange={handleInputChangeTable} handleDelete={handleDeleteTable} />
            </div>
        </Content>
    </div>
}

export default OrganizationManagementView;